<template>
    <div class="guest-info section">
        <h3>Tell us about yourself</h3>
        <fieldset class="guest">
            <my-input
                label="Guest name"
                name="guest.name"
                :required="true"
                placeholder="Guest Name"
                v-model="validator.name.$model"
                :validator="validator.name"
                errorMessage="Name is required"
                :readonly="readonly"
            />
            <my-input
                label="Email"
                name="guest.email"
                :required="true"
                type="email"
                placeholder="guest@example.com"
                v-model="validator.email.$model"
                :validator="validator.email"
                errorMessage="Valid email address is required"
                :readonly="readonly"
            />
            <my-input
                label="Phone"
                :required="true"
                placeholder="207-555-1212"
                v-model="validator.phone.$model"
                :validator="validator.phone"
                errorMessage="Phone number is required"
                :readonly="readonly"
            />
            <my-input
                label="Adults"
                :input-class="['number']"
                :required="true"
                v-model="validator.adults.$model"
                :validator="validator.adults"
                errorMessage="There must be at least 1 adult in the party"
                inputmode="numeric"
                pattern="[0-9]*"
                :readonly="readonly"
            />
            <my-input
                label="Children"
                :input-class="['number']"
                :required="true"
                v-model="validator.children.$model"
                :validator="validator.children"
                errorMessage="Number of children is required"
                inputmode="numeric"
                pattern="[0-9]*"
                :readonly="readonly"
            />
            <div class="field is-horizontal" v-if="totalGuests > maxGuests">
                <div class="field-label is-normal">
                    <label class="label"></label>
                </div>
                <div class="field-body">
                    <p
                        class="help is-danger"
                    >
                        {{ houseLabel }} sleeps up to {{ maxGuests }} people. Please adjust your guest counts.
                    </p>
                </div>
            </div>
            <my-input
                label="Pets"
                :input-class="['number']"
                :required="true"
                v-model="validator.pets.$model"
                :validator="validator.pets"
                errorMessage="Enter a number between 0 and 2"
                inputmode="numeric"
                pattern="[0-9]*"
                :info="'A maximum of 2 dogs is permitted with an additional pet fee and signed pet agreement.'"
                :readonly="readonly"
            />
            <my-input
                type="textarea"
                label="Comments"
                v-model="validator.comments.$model"
                :validator="validator.comments"
                :readonly="readonly"
            />
       </fieldset>
    </div>
</template>

<script>
// import { validationMixin } from 'vuelidate';
// import { required, integer, email, between } from 'vuelidate/lib/validators';
import MyInput from './form/MyInput.vue';

// const truthy = (value) => !! value;

export default {
    components: {
        MyInput,
    },
    // mixins: [ validationMixin ],
    props: {
        // guest: {
        //     type: Object,
        // },
        houseLabel: {
            type: String,
        },
        maxGuests: {
            type: Number,
        },
        validator: {
            type: Object,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },

    computed: {
        totalGuests() {
            return Number(this.validator.adults.$model || 0) + Number(this.validator.children.$model || 0);
        },
    },
}
</script>

<style lang="scss">
.guest-info {

    .number {
        width: 4em;
    }
}
</style>
